import React from 'react';
import { navigate } from '../Router';
import './GalleryPreview.css';

const GalleryPreview: React.FC = () => {
  // First 8 images to display on home page
  const previewImages = [
    '/images/WhatsApp Image 2026-01-13 at 8.04.02 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.03 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.04 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.06 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.11 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.17 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.18 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.21 PM.jpeg',
  ];

  return (
    <section className="gallery-preview-section">
      <div className="gallery-preview-container">
        <div className="gallery-header">
          <h2 className="gallery-title">Photo Gallery</h2>
          <p className="gallery-description">
            Explore our beautiful hotel, rooms, and the vibrant Pink City of Jaipur through our photo gallery.
          </p>
        </div>

        <div className="gallery-grid">
          {previewImages.map((image, index) => (
            <div key={index} className="gallery-item">
              <div className="gallery-image-wrapper">
                <img
                  src={image}
                  alt={`The Jaipur Hotels - Gallery ${index + 1}`}
                  loading="lazy"
                />
                <div className="gallery-overlay">
                  <span className="view-icon">🔍</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="gallery-cta">
          <button onClick={() => navigate('/gallery')} className="view-all-button">
            View All Photos
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default GalleryPreview;
